import { __decorate } from "tslib";
import { attr, DOM } from '@microsoft/fast-element';
import { SVG_SEARCH, SVG_CLOSE } from '@getgo/chameleon-icons';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import { TextFieldComponent } from '../TextField';
export class SearchFieldComponent extends ChameleonElementMixin(TextFieldComponent) {
    constructor() {
        super(...arguments);
        this.alignment = 'left';
        this.fieldsize = 'medium';
        this.setFieldSize = (value) => {
            var _a;
            this.size = (value.length || ((_a = this.placeholder) !== null && _a !== void 0 ? _a : '').length) + 1;
        };
        this.handleClearButtonClick = () => {
            this.value = '';
            this.handleChange();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.appendStartIcon();
        this.appendClearButton();
    }
    appendStartIcon() {
        var _a;
        const startSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('[name="start"]');
        const svg = document.createElement('chameleon-svg');
        svg.innerHTML = SVG_SEARCH;
        startSlot === null || startSlot === void 0 ? void 0 : startSlot.appendChild(svg);
    }
    appendClearButton() {
        var _a;
        const endSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('[name="end"]');
        const button = document.createElement('button');
        const endSvg = document.createElement('chameleon-svg');
        button.addEventListener('click', this.handleClearButtonClick);
        endSvg.innerHTML = SVG_CLOSE;
        button === null || button === void 0 ? void 0 : button.appendChild(endSvg);
        endSlot === null || endSlot === void 0 ? void 0 : endSlot.appendChild(button);
    }
    valueChanged(_oldValue, newValue) {
        super.valueChanged(_oldValue, newValue);
        DOM.queueUpdate(() => {
            if (this.alignment === 'center') {
                this.setFieldSize(newValue);
            }
        });
    }
    alignmentChanged(_oldValue, newValue) {
        DOM.queueUpdate(() => {
            if (newValue === 'center') {
                this.setFieldSize(this.value);
            }
            else {
                this.removeAttribute('size');
            }
        });
    }
}
__decorate([
    attr
], SearchFieldComponent.prototype, "alignment", void 0);
__decorate([
    attr
], SearchFieldComponent.prototype, "fieldsize", void 0);
